import React from "react";
import { FaUniversity, FaGraduationCap, FaCertificate } from "react-icons/fa";

const Education = () => {
  const educationList = [
    {
      year: "2024-2025",
      degree: "MSc Cloud Computing",
      institution: "University of Leicester, United Kingdom",
      icon: <FaGraduationCap />,
    },
    {
      year: "2020-2023",
      degree: "Bachelor's Of Computer Engineering ",
      institution: "Goa College of Engineering, Goa, India",
      icon: <FaUniversity />,
    },
    {
      year: "2017-2020",
      degree: "Diploma in Computer",
      institution: "Agnel Polytechnic Verna, Goa, India",
      icon: <FaCertificate />,
    },
  ];

  return (
    <section
      id="education"
      style={{
        padding: "50px",
        backgroundColor: "#000",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#fff",
        textAlign: "center",
      }}
    >
      <h2
        style={{
          marginBottom: "40px",
          fontSize: "2.5rem",
          fontWeight: "700",
        }}
      >
        Education
      </h2>

      <div
        style={{
          display: "inline-block",
          textAlign: "left",
          position: "relative",
          paddingLeft: "60px", // space for line + icons
        }}
      >
        {educationList.map((edu, index) => (
          <div
            key={index}
            style={{
              position: "relative",
              marginBottom: "50px",
              paddingLeft: "20px",
            }}
          >
            {/* Circle marker with icon */}
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                width: "40px",
                height: "40px",
                backgroundColor: "#00b894",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#000",
                fontSize: "1.2rem",
              }}
            >
              {edu.icon}
            </div>

            {/* Vertical line below icon */}
            {index !== educationList.length - 1 && (
              <div
                style={{
                  position: "absolute",
                  left: "18px", // center of icon
                  top: "40px", // start below icon
                  width: "4px",
                  height: "50px", // distance to next icon
                  backgroundColor: "#00b894",
                }}
              ></div>
            )}

            {/* Text content */}
            <div
              style={{ marginLeft: "60px", color: "#fff", fontSize: "1.2rem" }}
            >
              <h3 style={{ margin: "0 0 5px 0", fontSize: "1.5rem" }}>
                {edu.degree}
              </h3>
              <p style={{ margin: 0, color: "#ccc" }}>
                {edu.institution} | {edu.year}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
